var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMovementStbtc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6808_6007)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#0C1013"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 28.6C22.9588 28.6 28.6 22.9588 28.6 16C28.6 9.04121 22.9588 3.4 16 3.4C9.04121 3.4 3.4 9.04121 3.4 16C3.4 22.9588 9.04121 28.6 16 28.6ZM16 30C23.732 30 30 23.732 30 16C30 8.26801 23.732 2 16 2C8.26801 2 2 8.26801 2 16C2 23.732 8.26801 30 16 30Z",
    fill: "#FC6521"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6921 11.2185C19.9799 9.564 18.3392 9.21319 16.3298 9.55534L15.6854 7L14.1635 7.40279L14.7994 9.94947C14.4009 10.0534 13.9897 10.14 13.5827 10.257L12.9468 7.72329L11.4249 8.12608L12.0693 10.6814C11.7428 10.7767 9 11.4957 9 11.4957L9.41969 13.1588C9.41969 13.1588 10.5389 12.8383 10.5262 12.8643C11.1451 12.6997 11.4376 13.0159 11.5733 13.3147L13.3453 20.3181C13.3665 20.5217 13.3326 20.8681 12.9044 20.9851C12.9299 20.9981 11.798 21.2753 11.798 21.2753L11.9633 23.2156C11.9633 23.2156 14.6807 22.5053 15.0368 22.4143L15.6897 25L17.2116 24.5972L16.5587 21.9942C16.9784 21.8946 17.3854 21.7907 17.7796 21.6867L18.4283 24.2767L19.9502 23.8739L19.2973 21.2926C21.6417 20.7122 23.295 19.2007 22.9559 16.8922C22.7397 15.5019 21.2517 14.3585 20.0138 14.2286C20.7769 13.5399 21.1626 12.5351 20.6921 11.2185ZM19.9587 17.3123C20.2597 19.5991 17.1522 19.8807 16.1221 20.1535L15.2276 16.732C16.262 16.4591 19.4499 15.2984 19.9587 17.3123ZM18.0849 12.6564C18.4071 14.6877 15.7448 14.9259 14.8884 15.1511L14.0745 12.0457C14.9351 11.8248 17.432 10.7724 18.0849 12.6564Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6808_6007"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovementStbtc);
export default __webpack_public_path__ + "static/media/movement-stbtc.7317cff5116c1306636870bc9a9fd706.svg";
export { ForwardRef as ReactComponent };